module.exports = __webpack_public_path__ + "static/media/pilz.f68e7ed3.png";